export default function HowToPlayListItem(props: React.PropsWithChildren) {
  return <li className="mb-2">{props.children}</li>;
}

// This version of the list item is styled like the instruction menu from the
// original Spellcheck game. I kind of like it, so I'm leaving it here in case
// we decide to bring back the icons. The problem would be finding icons that
// fit each point in each game.
// interface ListItemProps {
//   icon: React.ReactNode;
//   children: React.ReactNode;
// }

// function ListItem(props: ListItemProps) {
//   return (
//     <li className="flex py-3">
//       <div className="min-w-12 flex flex-col justify-center">{props.icon}</div>
//       <div className="flex items-center grow-2">
//         <p>{props.children}</p>
//       </div>
//     </li>
//   );
// }
